import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Box, IconButton, Tooltip as MuiTooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { useData } from '../context/DataContext';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const DistribucionEmpleadosHorizontalBar = ({ selectedIndustries = [], onIndustryClick = () => {} }) => {
  const [infoOpen, setInfoOpen] = useState(false);
  const { getEmployeeDistribution, dataReady } = useData();

  // Get data from Excel (3 years)
  const excelData = dataReady ? getEmployeeDistribution() : { labels: [], data2022: [], data2023: [], data2024: [] };

  // Use Excel data or fallback
  const labels = excelData.labels.length > 0 ? excelData.labels : ['Micro', 'Pequeña', 'Mediana', 'Grande'];
  const data2022 = excelData.data2022.length > 0 ? excelData.data2022 : [0, 14, 19, 67];
  const data2023 = excelData.data2023.length > 0 ? excelData.data2023 : [2, 6, 14, 78];
  const data2024 = excelData.data2024.length > 0 ? excelData.data2024 : [1, 9, 24, 67];

  const chartData = {
    labels,
    datasets: [
      {
        label: '2023',
        data: data2022,
        backgroundColor: '#A2AEBB',
        borderColor: '#fff',
        borderWidth: 1,
      },
      {
        label: '2024',
        data: data2023,
        backgroundColor: '#476A8E',
        borderColor: '#fff',
        borderWidth: 1,
      },
      {
        label: '2025',
        data: data2024,
        backgroundColor: '#1F3D58',
        borderColor: '#fff',
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    layout: {
      padding: {
        top: 20,
        bottom: 50,
        left: 10,
        right: 50, // Espacio adicional para etiquetas
      },
    },
    plugins: {
      legend: { position: 'top' },
      datalabels: {
        color: '#000',
        anchor: 'end', // Posiciona las etiquetas al final de las barras
        align: 'right', // Alineación hacia la derecha, afuera de las barras
        offset: 8, // Desplaza las etiquetas hacia afuera de la barra
        formatter: (value) => (value !== null ? `${value}%` : ''),
        font: { weight: 'bold', size: 12 }, // Formato de la etiqueta
        clip: false, // Evita recortes si está fuera del canvas
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.raw}%`,
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Porcentaje (%)',
        },
        beginAtZero: true,
        max: 100,
        ticks: {
          stepSize: 10,
        },
      },
      y: {
        title: {
          display: true,
          text: 'Rango de Empleados',
        },
      },
    },
  };

  const infoContent = {
    formula: 'Total de empleados en un rango / Total de empleados x 100',
    description: 'Muestra la proporción porcentual de empleados clasificados por rangos de tamaño de empresa.',
  };

  return (
    <div style={{ maxWidth: '800px', height: '500px', margin: '0 auto', padding: '20px' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={-3}>
        <MuiTooltip title="Información de la gráfica">
          <IconButton onClick={() => setInfoOpen(true)}>
            <InfoIcon />
          </IconButton>
        </MuiTooltip>
      </Box>
      <div style={{ width: '100%', height: '550px' }}>
          <Bar data={chartData} options={options} />
      </div>
      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)}>
        <DialogTitle>Información de la Gráfica</DialogTitle>
        <DialogContent>
        <p><strong>Fórmula:</strong> {infoContent.formula}</p>
          <p><strong>Descripción:</strong> {infoContent.description}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DistribucionEmpleadosHorizontalBar;